import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';
import { crewLookupApiBase, type CrewLookupKind } from './registry';

export interface CrewLookupItem {
  id: number;
  code?: string | null;
  name: string;
  abrv?: string | null;
  phone?: string | null;
  email?: string | null;
  description?: string | null;
  categoryId?: number | null;
  category?: { id: number; code?: string | null; name: string; isActive?: boolean } | null;
  /** Ranks only — 1 = Officers, 2 = Ratings. */
  groupType?: number | null;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const useCrewLookupsList = (
  kind: CrewLookupKind,
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<CrewLookupItem> | CrewLookupItem[]>(
    `${crewLookupApiBase(kind)}${q}`,
    fetcher,
    { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse<CrewLookupItem>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useCrewLookupItem = (kind: CrewLookupKind, id: number) => {
  const { data, error, isLoading, mutate } = useSWR<CrewLookupItem>(
    id ? `${crewLookupApiBase(kind)}/${id}` : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
